module.exports = __webpack_public_path__ + "img/ray.72baff12.svg";